"use client";

import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { RotateCcw } from "lucide-react";
export default function LetsGetThisPartyStarted() {
  const [scrollY, setScrollY] = useState(0);
  const [showHeadline, setShowHeadline] = useState(false);
  const [headlineText, setHeadlineText] = useState("");
  const [showTagline, setShowTagline] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const originalBackgroundImage = "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1448648/img/image_unselrrn.jpg";
  const [backgroundImage, setBackgroundImage] = useState(originalBackgroundImage);
  const [isModified, setIsModified] = useState(false);
  const fullHeadline = "Let's Get This Party Started!";
  const tagline = "Fun, energetic, interactive — We bring the party";
  const handleRestore = () => {
    setBackgroundImage(originalBackgroundImage);
    setIsModified(false);
  };
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const timer1 = setTimeout(() => setShowHeadline(true), 300);
    return () => clearTimeout(timer1);
  }, []);
  useEffect(() => {
    if (!showHeadline) return;
    let index = 0;
    const typeInterval = setInterval(() => {
      if (index <= fullHeadline.length) {
        setHeadlineText(fullHeadline.slice(0, index));
        index++;
      } else {
        clearInterval(typeInterval);
        setTimeout(() => setShowTagline(true), 200);
        setTimeout(() => setShowButton(true), 600);
      }
    }, 80);
    return () => clearInterval(typeInterval);
  }, [showHeadline]);
  return <section className="relative h-screen w-full overflow-hidden bg-dark-background">
      <div className="absolute inset-0 bg-cover bg-center transition-all duration-500" style={{
      backgroundImage: `url(${backgroundImage})`,
      transform: `translateY(${scrollY * 0.5}px)`
    }} />
      <div className="absolute inset-0 bg-dark-background/40" />

      <div className="absolute top-4 right-4 z-20">
        <Button onClick={handleRestore} disabled={!isModified} size="sm" variant="outline" className="bg-background/80 backdrop-blur-sm border-border hover:bg-background/90 disabled:opacity-50 disabled:cursor-not-allowed shadow-medium transition-all duration-[var(--duration-medium)]" title="Restore original background">
          <RotateCcw />
          <span className="hidden sm:inline">Restore</span>
        </Button>
      </div>

      <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-center bg-cover bg-center bg-[url(/img/party_celebration_background.jpg)]">
        <div className="relative z-10">
          <h1 className="font-display text-5xl md:text-7xl font-extrabold text-foreground-dark mb-4" style={{
          minHeight: "5rem"
        }}>
            {headlineText}
            {showHeadline && headlineText.length < fullHeadline.length && <span className="animate-pulse">|</span>}
          </h1>
          <p className={`font-sans text-lg md:text-2xl text-foreground-dark/90 max-w-2xl mb-8 md:ml-36 transition-all duration-[var(--duration-slow)] ${showTagline ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            It is YOUR day - We just amplify it
          </p>
          <div className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${showButton ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <Link to="/HomePage">
              <Button size="lg" className="bg-dark-background text-foreground-dark hover:bg-dark-background/90 active:bg-dark-background/80 transform hover:scale-105 transition-all duration-[var(--duration-medium)] shadow-strong font-semibold px-8 py-6 text-lg">
                Book Your Event
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}